import { getEdificiosListadoPublico, calcularResumenRedComercial } from "../../utils";

// Fase B, precarga (2026-09-26): ÚNICO lugar donde se declaran las consultas que usan las láminas
// del mediakit (10.1) — MediakitDataProvider las dispara TODAS en paralelo al montar el visor.
// Cada lámina futura con datos vivos suma su entrada acá; nunca dispara su propio fetch (ver
// laminas/Lamina03Crecimiento.js, que solo LEE del proveedor).
export const MEDIAKIT_DATA_SOURCES = {
  resumenRed: async () => {
    const edificios = await getEdificiosListadoPublico({ pais: "Chile" });
    return calcularResumenRedComercial(edificios);
  },
};
